import React, { useEffect, useState } from 'react'
import './App.scss'
import firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/auth'

import Card from './components/Card';
import crypto from 'crypto-js'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
      apiKey: process.env.REACT_APP_API_KEY,
      authDomain: process.env.REACT_APP_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_PROJECT_ID,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};



if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      // firebase.firestore().settings({ experimentalForceLongPolling: true }); //add this..
      // firebase.firestore().settings({
      //       cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
      // })
      // firebase.firestore().enablePersistence()

}
const db = firebase.firestore()


// const setFillHeight = () => { const vh = window.innerHeight * 0.01; document.documentElement.style.setProperty('--vh', `${vh}px`); }  // 画面のサイズ変動があった時に高さを再計算する 
// window.addEventListener('resize', setFillHeight);  // 初期化 
// setFillHeight();


function App() {
      const [user, setUser] = useState('');
      const [password, setPassword] = useState('');
      const [manabaId, setManabaId] = useState('');
      const [manabaURL, setManabaURL] = useState('https://ct.ritsumei.ac.jp');
      const [lineNotifyToken, setLineNotifyToken] = useState(null);
      const [isRevealPassword, setIsRevealPassword] = useState(false);
      const [tasklist, setTasklist] = useState(null);
      const [isRevealConfig, setIsRevealConfig] = useState(false);
      let uid = null;

      const getTasksFromFirestore = async () => {
            if (user) {
                  try {
                        const snapshot = await db.collection('task-list').doc(uid).get();
                        const json = snapshot.data()
                        // console.log(json);
                        const keyList = Object.keys(json).sort();
                        let tasks = [];
                        console.log(keyList);
                        keyList.forEach(t => {
                              // console.log(json[t]);
                              tasks.push(json[t]);
                        });
                        setTasklist(tasks);
                  } catch (error) {
                        console.log(error)
                        await db.collection("users").doc(uid).set({
                              'username': '',
                              'password': '',
                              'manaba_url': '',
                              'LINE_NOTIFY_TOKEN': ''
                        }).catch(() => {
                              console.log('error')
                        });

                        await db.collection("task-list").doc(uid).set({
                              'username': {
                                    "task": 'Google認証成功',
                                    "subject": '下のconfigから設定を行ってください',
                                    "deadline": 'manabaのアカウントを登録をしてください',
                                    "url": 'https://manaba.jp/',
                              }
                        }).catch(() => {
                              console.log('error')
                        });
                        if (user) {//Googleログイン済みのもののみreload
                              setTimeout(
                                    () => {
                                          window.location.reload();
                                    }
                                    , 8000);
                        }
                  }
            }
      }
      useEffect(() => {
            firebase.auth().onAuthStateChanged(usr => {
                  setUser(usr);
            });
      }, []);

      const sendIds = async () => {
            if (user) {
                  // eslint-disable-next-line
                  if (password !== '' && manabaId !== '') {
                        const password_ = manabaId;
                        const salt = uid;
                        const iterations = 128;
                        const bytes = crypto.PBKDF2(password_, salt, { keySize: 48, iterations: iterations });
                        const iv = crypto.enc.Hex.parse(bytes.toString().slice(0, 32));
                        const key = crypto.enc.Hex.parse(bytes.toString().slice(32, 96));

                        const ciphertext = crypto.AES.encrypt(password, key, { iv: iv });
                        const encrypted = ciphertext.toString();
                        console.log(ciphertext.toString());

                        await db.collection("users").doc(uid).set({
                              'username': manabaId,
                              'password': encrypted,
                              'manaba_url': manabaURL,
                              'LINE_NOTIFY_TOKEN': lineNotifyToken
                        }).catch((e) => {
                              console.log('error', e)
                              alert('error', e);
                        });
                        alert('設定を保存しました。10分後に再度開いてください。');
                  } else {
                        // eslint-disable-next-line
                        if (password == '') {
                              // eslint-disable-next-line
                              if (manabaId == '') {
                                    alert('manabaのIDとパスワードを入力してください');
                              } else {
                                    alert('manabaのパスワードを入力してください');
                              }
                        } else {
                              // eslint-disable-next-line
                              if (manabaId == '') {
                                    alert('manabaのIDを入力してください');
                              }
                        }
                  }
            }
      }

      const showTasks = () => {
            if (tasklist != null) {
                  return tasklist.map((task, index) => {
                        return (<Card url={task["url"]} deadline={task["deadline"]} task={task["task"]} subject={task["subject"]} index={index} />)
                  });
            }
      }


      const onChangePassword = (event) => { setPassword(event.target.value); }
      const onChangeManabaId = (event) => { setManabaId(event.target.value); }
      const onChangeManabaURL = (event) => { setManabaURL(event.target.value); }
      const onChangeLineNotifyToken = (event) => { setLineNotifyToken(event.target.value); }
      const login = () => {
            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithRedirect(provider);
      };

      const logout = () => {
            firebase.auth().signOut();
      }


      uid = String(user && user.uid);

      //         
      console.log(uid);
      console.log(manabaId); console.log(password); console.log(manabaURL);
      if (uid != null && tasklist == null) { //&&にしないと無限に読み込むので注意
            getTasksFromFirestore();
      }

      return (
            <div className="App">
                  {user ? (
                        <>
                              <div className="wrapper">
                                    {/* <div className="card">
                                                <div>
                                                      <a href="https://ct.ritsumei.ac.jp/s/course_4238244_report_5501644">
                                                            <h1>数学Ⅳ（線形代数）(5T)</h1>
                                                      </a>
                                                      <div className="child">
                                                            <div className="titlebox">
                                                                  <p className="title">第１回目の課題</p>
                                                            </div>

                                                            <p className="deadline">10/04 23:55</p>
                                                      </div>
                                                </div>
                                          </div>
                                          <div className="card">
                                                <div>
                                                      <a href="https://ct.ritsumei.ac.jp/s/course_4238244_report_5501644">
                                                            <h1>理工学部 1回生 秋学期ガイダンス</h1>
                                                      </a>
                                                      <div className="child">
                                                            <div className="titlebox">
                                                                  <p className="title">マイコン応用実験キットの送付先</p>
                                                            </div>
                                                            <p className="deadline">10/04 23:55</p>
                                                      </div>
                                                </div>
                                          </div> */}
                                    {showTasks()}

                              </div>
                              <footer>
                                    <button onClick={async () => {
                                          setIsRevealConfig(!isRevealConfig);

                                    }} >Configs</button>
                              </footer>
                              {isRevealConfig ? (<div className='form_'>
                                    <p className="uid">
                                          UID: {uid}
                                    </p>
                                    <form>
                                          <div>
                                                <label>
                                                      <input
                                                            type="string"
                                                            name="id"
                                                            id="id"
                                                            placeholder="manabaID"
                                                            value={manabaId}
                                                            onChange={onChangeManabaId}
                                                      />
                                                </label>
                                          </div>
                                          <div>
                                                <label>
                                                      <input
                                                            type={isRevealPassword ? 'text' : 'password'}
                                                            name="password"
                                                            id="password"
                                                            placeholder="manaba password"
                                                            value={password}
                                                            onChange={onChangePassword}
                                                      />

                                                      <span
                                                            className="PasswordReveal"
                                                            role="presentation"
                                                            onClick={() => { setIsRevealPassword((prevState) => !prevState) }}
                                                      >
                                                            <i className={`fas fa-${isRevealPassword ? "eye" : "eye-slash"}`} />
                                                      </span>
                                                </label>
                                          </div>
                                          <div>
                                                <label>
                                                      <input
                                                            placeholder="url ct.ritsumei.ac.jp"
                                                            value={manabaURL}
                                                            name="url"
                                                            onChange={onChangeManabaURL}
                                                      />

                                                </label>
                                          </div>
                                          <div>
                                                <label>
                                                      <input
                                                            placeholder="LINE Notify Token"
                                                            value={lineNotifyToken}
                                                            name="id"
                                                            onChange={onChangeLineNotifyToken}
                                                      />
                                                </label>
                                          </div>
                                    </form>
                                    <div className='sendPass'>
                                          <button onClick={logout}>Logout</button>
                                          <button type="button" onClick={() => {
                                                sendIds();
                                          }}>send</button>

                                    </div>

                              </div>) : (
                                    <></>
                              )}
                        </>
                  ) : (<>
                        <div className="login">
                              <div>
                                    <img src="icon.png" alt="icon" />
                              </div>
                              <div>
                                    <button onClick={login}>Google Login</button>
                              </div>
                        </div>
                  </>
                  )}
            </div>
      )
}

export default App